import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenConfigEventsController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigEventsController.php
* @route '/api/screen/data/get-events'
*/
const GetScreenConfigEventsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigEventsController.url(options),
    method: 'get',
})

GetScreenConfigEventsController.definition = {
    methods: ["get","head"],
    url: '/api/screen/data/get-events',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigEventsController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigEventsController.php
* @route '/api/screen/data/get-events'
*/
GetScreenConfigEventsController.url = (options?: RouteQueryOptions) => {
    return GetScreenConfigEventsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigEventsController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigEventsController.php
* @route '/api/screen/data/get-events'
*/
GetScreenConfigEventsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenConfigEventsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenConfigEventsController::__invoke
* @see app/Http/Controllers/Screen/GetScreenConfigEventsController.php
* @route '/api/screen/data/get-events'
*/
GetScreenConfigEventsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenConfigEventsController.url(options),
    method: 'head',
})

export default GetScreenConfigEventsController